export const nameFields = {
  totalItens: 'Colaboradores',
  totalRechargeValue: 'Valor do pedido',
  administrateFee: 'Taxa administrativa',
  totalTransferFeeValue: 'Taxa de repasse',
  ticketingBalance: 'Conta corrente',
  issFee: 'Retenção ISS',
  totalValue: 'Valor total',
}
